export enum DeclarationType {
  VatDeclaration,
  Suppletion,
}
